import React, { createContext, useContext, useState, useEffect } from 'react';
import { pb } from '../lib/pocketbase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Vérifier l'état de connexion au chargement
  useEffect(() => {
    const unsubscribe = pb.authStore.onChange((token, model) => {
      setCurrentUser(model);
      setLoading(false);
    });

    // Vérifier si l'utilisateur est déjà connecté
    setCurrentUser(pb.authStore.model);
    setLoading(false);

    return () => unsubscribe();
  }, []);

  // S'inscrire
  const signup = async (email, password, name) => {
    const data = {
      email,
      password,
      passwordConfirm: password,
      name,
      emailVisibility: true,
    };

    await pb.collection('users').create(data);
    await login(email, password);
  };

  // Se connecter
  const login = async (email, password) => {
    await pb.collection('users').authWithPassword(email, password);
  };

  // Se déconnecter
  const logout = async () => {
    pb.authStore.clear();
  };

  // Mettre à jour le profil
  const updateProfile = async (profileData) => {
    if (!currentUser) throw new Error('Utilisateur non connecté');
    
    const updated = await pb.collection('users').update(currentUser.id, {
      name: profileData.name,
      email: profileData.email,
      phone: profileData.phone || '',
      address: profileData.address || ''
    });
    
    setCurrentUser(updated);
    return updated;
  };

  // Changer le mot de passe
  const changePassword = async (currentPassword, newPassword) => {
    if (!currentUser) throw new Error('Utilisateur non connecté');
    
    // Vérifier le mot de passe actuel
    await pb.collection('users').authWithPassword(currentUser.email, currentPassword);
    
    // Changer le mot de passe
    await pb.collection('users').update(currentUser.id, {
      password: newPassword,
      passwordConfirm: newPassword
    });
  };

  // Vérifier si l'utilisateur est admin
  const isAdmin = currentUser?.collectionName === '_superusers' || 
                 currentUser?.role === 'admin';

  const value = {
    currentUser,
    isAdmin,
    login,
    signup,
    logout,
    updateProfile,
    changePassword,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
